// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__3wkVe","content":"LayoutSettings_content__3Tcjm"};